import React, { useState, useEffect } from "react";
import { uploadFile, uploadMerchand } from "../../DAL/create";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  TextField,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import SVGAAnimation from "../../Components/SVGAAnimation";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchCategoriesList,
  fetchProductDetail,
  GetMerchandDetail,
  GetProductDetail,
} from "../../DAL/fetch";
import { fileUrl } from "../../Config/Config";
import { updateSingleMerchandData } from "../../DAL/update";
import { useSnackbar } from "notistack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function AddMerchand() {
  const { enqueueSnackbar } = useSnackbar();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [fileName, setFileName] = useState("");
  const [file2, setFile2] = useState(null);
  const [fileName2, setFileName2] = useState("");
  const [fileUploaded1, setFileUploaded1] = useState(false);
  const [fileUploaded2, setFileUploaded2] = useState(false);
  const [fileURL1, setFileURL1] = useState("");
  const [fileURL2, setFileURL2] = useState("");
  const [filePreview, setFilePreview] = useState(null);
  const [filePreview2, setFilePreview2] = useState(null);
  const [inputs, setInputs] = useState({
    name: "",
    country: "",
    email: "",
    phone: "",
    address: "",
    user_name: "",
    password: "",
    bank_name: "",
    bank_account_number: "",
    whatsapp: "",
  });
  const [type, setType] = useState("add");
  const [types, setTypes] = useState(false);
  const [message, setMessage] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleSingleId = async () => {
    const resp = await GetMerchandDetail(id);
    if (resp?.status == 200) {
      setInputs(resp?.data?.data);
      setFilePreview(resp?.data?.data?.picture);
      setType("edit");
    }
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleFileSubmit1 = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage(true);
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    setLoading(true);
    try {
      const imagedata = await uploadFile(formData);
      setFileURL1(imagedata.data.url);
      setFileUploaded1(true);
      enqueueSnackbar("File uploaded successfully!", { variant: "success" });
    } catch (error) {
      console.error("Error uploading file:", error);
      enqueueSnackbar("Failed to upload file. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const fileInputRef = React.useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    if (inputs?.name == "") {
      setTypes(true);
      return;
    }
    if (inputs?.email == "") {
      setTypes(true);
      return;
    }
    if (!inputs?.phone) {
      setTypes(true);
      return;
    }
    if (inputs?.address == "") {
      setTypes(true);
      return;
    }
    if (inputs?.user_name == "") {
      setTypes(true);
      return;
    }
    if (inputs?.bank_name == "") {
      setTypes(true);
      return;
    }
    if (inputs?.bank_account_number == "") {
      setTypes(true);
      return;
    }
    if (!inputs?.whatsapp) {
      setTypes(true);
      return;
    }

    e.preventDefault();
    const formData = new FormData();
    formData.append("name", inputs?.name);
    formData.append("country", inputs?.country);
    formData.append("email", inputs?.email);
    formData.append("phone", inputs?.phone);
    formData.append("address", inputs?.address);
    formData.append("user_name", inputs?.user_name);
    formData.append("password", inputs?.password);
    formData.append("bank_name", inputs?.bank_name);
    formData.append("bank_account_number", inputs?.bank_account_number);
    formData.append("whatsapp", inputs?.whatsapp);
    formData.append("picture", fileURL1 || filePreview);

    setLoading(true);
    const resp =
      type == "add"
        ? await uploadMerchand(formData)
        : await updateSingleMerchandData(id, formData);
    if (resp?.status == 201 || resp?.status == 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      navigate("/merchant");
    } else {
      enqueueSnackbar(
        resp?.data?.message ||
          resp?.data?.error ||
          resp?.message ||
          resp?.error,
        { variant: "error" }
      );
    }
  };

  useEffect(() => {
    if (id) {
      handleSingleId();
    }
  }, [id]);

  const labelStyles = {
    color: "",
    "&.Mui-focused": {
      color: "#8F29D0",
    },
  };
  const inputStyles = {
    marginBottom: 2,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#8F29D0",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8F29D0",
      },
    },
  };

  return (
    <Box>
      <ArrowBackIcon
        sx={{
          cursor: "pointer",
          position: "absolute",
          top: "25px",
          left: "18%",
        }}
        onClick={() => navigate(-1)}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          alignItems: "center",
          maxWidth: 400,
          margin: "auto",
          mt: 4,
        }}
      >
        <Typography variant="h6">
          {type == "add" ? "Create New Merchant" : "Update Merchant"}
        </Typography>
        <TextField
          fullWidth
          required
          name="name"
          label="Merchant Name"
          variant="outlined"
          value={inputs?.name}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
        />
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types == true && !inputs?.name && " name is Required"}
        </FormHelperText>
        <TextField
          fullWidth
          required
          label="Country"
          name="country"
          variant="outlined"
          value={inputs?.country}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
        />
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types == true && !inputs.country && " Country is Required"}
        </FormHelperText>
        <TextField
          fullWidth
          required
          label="Merchant Email"
          name="email"
          variant="outlined"
          value={inputs?.email}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
        />
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types == true && !inputs.email && " Email is Required"}
        </FormHelperText>
        <TextField
          fullWidth
          required
          label="Phone"
          variant="outlined"
          name="phone"
          value={inputs?.phone}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
        />
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types == true && !inputs.phone && " Phone is Required"}
        </FormHelperText>
        <TextField
          fullWidth
          required
          name="address"
          label="Merchant address"
          variant="outlined"
          value={inputs?.address}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
        />
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types == true && !inputs.address && " Address is Required"}
        </FormHelperText>
        <TextField
          fullWidth
          required
          name="user_name"
          label="Merchant user_name"
          variant="outlined"
          value={inputs?.user_name}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
        />
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types == true && !inputs.user_name && " User name is Required"}
        </FormHelperText>
        {!id && (
          <>
            <TextField
              fullWidth
              required
              name="password"
              label="Password"
              variant="outlined"
              type="password"
              value={inputs?.password}
              onChange={handleChange}
              sx={inputStyles}
              InputLabelProps={{ sx: labelStyles }}
            />
            <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
              {types == true && !inputs.password && " password is Required"}
            </FormHelperText>
          </>
        )}
        <TextField
          fullWidth
          required
          name="bank_name"
          label="bank_name"
          variant="outlined"
          value={inputs?.bank_name}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
        />
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types == true && !inputs.bank_name && " Bank name is Required"}
        </FormHelperText>
        <TextField
          fullWidth
          required
          name="bank_account_number"
          label="bank_account_number"
          variant="outlined"
          value={inputs?.bank_account_number}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
        />
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types == true &&
            !inputs.bank_account_number &&
            " bank Account is Required"}
        </FormHelperText>
        <TextField
          fullWidth
          required
          name="whatsapp"
          label="whatsapp"
          variant="outlined"
          value={inputs?.whatsapp}
          onChange={handleChange}
          sx={inputStyles}
          InputLabelProps={{ sx: labelStyles }}
        />
        <FormHelperText sx={{ color: "red", marginTop: "-30px" }}>
          {types == true && !inputs.whatsapp && " Whatsapp is Required"}
        </FormHelperText>

        <Typography variant="h6">Upload Image </Typography>

        <Box sx={{ width: "100%", display: "flex", gap: 2 }}>
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleFileChange}
          />
          <Button
            variant="contained"
            color={fileUploaded1 ? "success" : "primary"}
            onClick={handleFileSubmit1}
            disabled={loading || !file}
            sx={{ textTransform: "none" }}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : fileUploaded1 ? (
              "Uploaded"
            ) : (
              "Upload"
            )}
          </Button>
        </Box>
        {file && (
          <Button
            onClick={() => {
              setFile(null);
              setFileName("");
              setFileUploaded1(false);
              setFileURL1("");
              if (fileInputRef.current) fileInputRef.current.value = "";
            }}
            size="small"
            sx={{
              textTransform: "none",
              color: "red",
              alignSelf: "flex-start",
              marginTop: "-10px",
            }}
          >
            Remove File
          </Button>
        )}

        {fileName && <Typography variant="body2">{fileName}</Typography>}
        <FormHelperText sx={{ color: "red" }}>
          {message == true && !file && "Image file is Required"}
        </FormHelperText>

        {filePreview && (
          <Box sx={{ mt: 2 }}>
            <img
              src={
                filePreview?.startsWith("/")
                  ? fileUrl + filePreview
                  : filePreview
              }
              alt="Preview"
              style={{ maxWidth: "100%", maxHeight: "200px" }}
            />
          </Box>
        )}

        <Button
          variant="contained"
          className="gradientButton"
          onClick={handleSubmit}
          fullWidth
          sx={{ marginBottom: "20px", textTransform: "none" }}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
}

export default AddMerchand;
